import { render } from "./Audio.vue?vue&type=template&id=7c40b22e&scoped=true"
import script from "./Audio.vue?vue&type=script&lang=ts"
export * from "./Audio.vue?vue&type=script&lang=ts"

import "./Audio.vue?vue&type=style&index=0&id=7c40b22e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7c40b22e"

export default script